<div fxLayout="row" fxLayoutAlign="start">
  <abcButton #addRowButton [id]="'buttonAdd'" [image]="'assets/images/Neu_128x128-32.png'" [class]="'documents-button'">
  </abcButton>
  <abcButton
    #deleteRowButton
    [id]="'buttonDelete'"
    [image]="'assets/images/Loeschen_128.png'"
    [class]="'documents-button'"
  ></abcButton>
  <abcButton
    #hideGroupingButton
    [id]="'buttonHideGroupingButton'"
    [class]="'documents-button'"
    [image]="'assets/images/GroupPanelVisibilityLarge.png'"
    matTooltip="Display / hide the grouping field"
  >
  </abcButton>
</div>

<div #documentGridContainer id="documentGridContainer"></div>

<div #abcWindowContainer id="abcWindowContainer"></div>

<div #documentLoaderContainer id="hignaLoaderContainer"></div>
